import React from "react";
import pictureOne from "./assets/picOne.png";
import { Link } from "react-router-dom";

const StandardsServices = () => {
  return (
    <div className="about-us">

      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">WTO-TBT/SPS National Enquiry Point</h1>
          <p className="subtitle">
            Providing access to standards, technical regulations, and conformity assessment information for enterprises.
          </p>
        </div>
      </section>

      {/* === WTO-TBT/SPS National Enquiry Point Section === */}
      <section className="what-section">
        <p>
          One of the main problems enterprises from developing countries face in promoting exports is the lack of information on standards, technical regulations, and conformity assessment procedures applicable to their product(s) in target markets.
        </p>
        <p>
          Under the World Trade Organisation’s (WTO) Agreements on Sanitary and Phytosanitary (SPS) and Technical Barriers to Trade (TBT), the Malawi Government designated the MBS as the SPS National Enquiry Point (NEP) responsible for food safety, and as the TBT National Enquiry Point. The WTO recommends the establishment of NEPs so that countries could easily obtain information about SPS and TBT related issues, without having to identify and directly contact the agency responsible for any given function in another country.
        </p>
        <p>
          The NEP therefore provides answers from relevant national bodies, importers, exporters and replies to the country making the enquiry as well as for the provision of relevant documents. The enquiry point also provides, upon request, information on participation in bilateral and multilateral equivalence agreements and arrangements.
        </p>
        <p>
          The business sector is hence encouraged to make use of the NEP to obtain information regarding standards, technical regulations, food safety measures and certification requirements of these products in the importing countries.
        </p>
        <p>Enquiries to the MBS as NEP for SPS (Food safety) and TBT can be made through:</p>
        <address>
          Director General<br />
          Malawi Bureau of Standards<br />
          P.O. Box 946<br />
          Blantyre<br />
          Tel: +265 891 373 444<br />
          E-mail: <a href="mailto:info@mbsmw.org">info@mbsmw.org</a>
        </address>

        {/* === Optional Link (if you have a page for enquiries) === */}
        {/* <p style={{ marginTop: "20px" }}>
          For more information, visit:{" "}
          <Link to="/applyNEP" style={{ color: "red", textDecoration: "none", fontWeight: "bold" }}>
            Apply/Enquire here
          </Link>.
        </p> */}
      </section>

      {/* === Inline CSS === */}
      <style>{`
        .about-us { font-family: Arial, sans-serif; color: #333; }

        .about-header {
          background-image: url(${pictureOne});
          background-size: cover;
          background-position: center;
          height: 45vh;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }

        .overlay {
          background: rgba(0,0,0,0.55);
          padding: 40px;
          text-align: center;
          color: white;
          width: 90%;
          max-width: 1200px;
          box-sizing: border-box;
          border-radius: 8px;
        }

        .page-title { font-size: 2.5rem; font-weight: bold; }
        .subtitle { margin-top: 10px; font-size: 1rem; }

        .what-section { padding: 50px 80px; font-size: 1rem; line-height: 1.6; }
        .what-section ul { margin-left: 20px; margin-bottom: 20px; }
        .what-section li { margin-bottom: 10px; }
        address { margin-top: 15px; line-height: 1.5; font-style: normal; }
        address a { color: red; text-decoration: none; }
      `}</style>

    </div>
  );
};

export default StandardsServices;
